import Slide from '@material-ui/core/Slide';

const SlideUp = (props) => {
  return <Slide {...props} direction="up" />;
};

export default SlideUp;
